<template>
  <div class="flex-column float-btn">
    <div class="btn" @mouseenter="onEnter(0)" @mouseleave="onLeave">
      <img :src="hoverIndex === 0 ? '/images/fudong-lubanbai.png' : '/images/fudong-luban.png'" alt="">
    </div>
    <div class="btn" @mouseenter="onEnter(1)" @mouseleave="onLeave">
      <img :src="hoverIndex === 1 ? '/images/fudong-telbai.png' : '/images/fudong-tel.png'" alt="">
    </div>
    <div class="btn" @mouseenter="onEnter(2)" @mouseleave="onLeave">
      <img :src="hoverIndex === 2 ? '/images/fudong-weixinbai.png' : '/images/fudong-weixin.png'" alt="">
    </div>
    <div class="btn" @mouseenter="onEnter(3)" @mouseleave="onLeave" @click="backTop">
      <img :src="hoverIndex === 3 ? '/images/fudong-topbai.png' : '/images/fudong-top.png'" alt="">
    </div>
  </div>
</template>

<script>

export default {
  name: "FloatButton",
  components: {},
  data () {
    return {
      hoverIndex: null
    }
  },
  created () {},
  mounted () {
  },
  methods: {
    onEnter (e) {
      this.hoverIndex = e
    },
    onLeave () {
      this.hoverIndex = null
    },
    backTop() {
      let timer = setInterval(() => {
        let osTop = document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 7); 
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        this.isTop = true;
        if(osTop === 0){
          clearInterval(timer);
        }
      },30)
    }
  }
};
</script>

<style lang="scss" scoped>
  .btn{
    height: 64px;
    width: 64px;
    box-shadow: 0 10px 10px 0 rgba(41, 42, 46, 0.05);
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-radius: 50%;
    margin-bottom: 10px;
    cursor: pointer;
    &:hover{
      background: #c19357;
      box-shadow: 0 10px 10px 0 rgba(193, 147, 87, 0.25);
    }
  }
  .float-btn{
    position: fixed;
    bottom: 200px;
    right: 4vw;
    z-index: 10;  
  }
</style>
